import React from 'react';
import InjectScript from "../../CustomScript";

const GoogleNewsSidebar = () => {
  const adtwoHardcode4 =
    "" +
    "<div id='div-gpt-ad-1645339970921-0' class='ad-placeholder' style='min-width: 300px; min-height: 250px; margin: 0 auto;'>  " +
    "<script>" +
    " window.googletag = window.googletag || {cmd: []}; " +
    "googletag.cmd.push(function() { " +
    "googletag.defineSlot('/22678428348/SDPL_HP_Desktop_ATF_300X250', [300, 250], 'div-gpt-ad-1645339970921-0').addService(googletag.pubads());  " +
    "googletag.pubads().enableSingleRequest(); " +
    "googletag.pubads().disableInitialLoad();" +
    " googletag.enableServices(); " +
    "});" +
    "</script>" +
    "" +
    "<script>" +
    " googletag.cmd.push(function() { googletag.display('div-gpt-ad-1645339970921-0'); });   " +
    "</script>" +
    "</div>";

  const adtwoHardcode166 =
    "" +
    "<div id='div-gpt-ad-1646309696587-0' class='ad-placeholder' style='min-width: 300px; min-height: 250px; margin: 0 auto;'>  " +
    "<script>" +
    "window.googletag = window.googletag || {cmd: []};" +
    "googletag.cmd.push(function() { " +
    "googletag.defineSlot('/22678428348/Mweb_HP_Desktop_ATF_300X250', [300, 250], 'div-gpt-ad-1646309696587-0').addService(googletag.pubads()); " +
    "googletag.pubads().enableSingleRequest();" +
    "googletag.pubads().disableInitialLoad(); " +
    "googletag.enableServices();  " +
    "});" +
    "</script>" +
    "" +
    "<script>" +
    " googletag.cmd.push(function() { googletag.display('div-gpt-ad-1646309696587-0'); });   " +
    "</script>" +
    "</div>";

  return (
    <div className="ad-sidebar-container d-flex flex-column gap-3">
      {/* Google News Banner */}
      <div
        className="google-news-promo-gujarati"
        style={{
          width: "100%",
          position: "relative",
          marginBottom: "5px",
          marginTop: "5px",
        }}
      >
        <style>
          {`
            @keyframes sheen {
              0% { transform: translateX(-100%) skewX(-15deg); }
              100% { transform: translateX(200%) skewX(-15deg); }
            }
            @keyframes page-float {
              0%, 100% { transform: translateY(0) scale(1); }
              50% { transform: translateY(-2px) scale(1.02); }
            }
            @keyframes pulse-blue {
              0% { box-shadow: 0 0 0 0 rgba(26, 115, 232, 0.4); }
              70% { box-shadow: 0 0 0 6px rgba(26, 115, 232, 0); }
              100% { box-shadow: 0 0 0 0 rgba(26, 115, 232, 0); }
            }
            .g-btn-shine {
              position: relative;
              overflow: hidden;
            }
            .g-btn-shine::after {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              width: 50%;
              height: 100%;
              background: rgba(255,255,255,0.4);
              transform: translateX(-150%) skewX(-15deg);
              animation: sheen 3s infinite;
            }
            .news-icon-anim {
                animation: page-float 3s ease-in-out infinite;
            }
            .trusted-badge-anim {
                animation: pulse-blue 2s infinite;
            }
            .g-news-card-detail:hover {
              transform: translateY(-2px);
              box-shadow: 0 6px 15px rgba(0,0,0,0.1) !important;
            }
          `}
        </style>
        <a
          href="https://www.google.com/preferences/source?q=sandesh.com"
          target="_blank"
          rel="noreferrer"
          className="g-news-card g-news-card-detail"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "#ffffff",
            borderRadius: "9px",
            padding: "8px",
            textDecoration: "none",
            border: "1px solid #e0e0e0",
            borderTop: "3px solid #D32F2F", // Sandesh Red Theme
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            transition: "all 0.3s ease",
            minHeight: "auto",
            textAlign: "center"
          }}
        >
          {/* Google News Icon & Trusted Source Label */}
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginBottom: "3px" }}>
            <div className="news-icon-anim" style={{ position: "relative", width: "36px", height: "27px", marginBottom: "1px" }}>
              <svg width="100%" height="100%" viewBox="0 0 40 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 8H28V24H8Z" fill="#34A853" opacity="0.8" />
                <path d="M12 5H32V21H12Z" fill="#FBBC04" opacity="0.9" />
                <path d="M16 2H36V18H16Z" fill="#EA4335" />
                <rect x="12" y="8" width="24" height="18" rx="2" fill="#4285F4" />
                <path d="M16 13H32" stroke="white" strokeWidth="2" strokeLinecap="round" />
                <path d="M16 17H32" stroke="white" strokeWidth="2" strokeLinecap="round" />
                <path d="M16 21H24" stroke="white" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            <div className="trusted-badge-anim" style={{
              display: "flex",
              alignItems: "center",
              gap: "3px",
              background: "#E8F0FE",
              padding: "2px 6px",
              borderRadius: "10px",
              border: "1px solid #d2e3fc"
            }}>
              <span style={{ fontSize: "9px", fontWeight: "700", color: "#1967d2", letterSpacing: "0.3px", textTransform: "uppercase" }}>Trusted Source</span>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="#1A73E8">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
              </svg>
            </div>
          </div>

          <div style={{ marginBottom: "4px" }}>
            <h3 style={{
              margin: 0,
              fontSize: "13px",
              fontWeight: "800",
              color: "#2D2D2D",
              lineHeight: "1.3",
              fontFamily: "'Hind Vadodara', sans-serif"
            }}>
              સંદેશને Google પર મનપસંદ સોર્સ બનાવો
            </h3>
          </div>

          <div
            className="g-btn-main g-btn-shine"
            style={{
              background: "#ae0a0b",
              color: "#fff",
              width: "100%",
              padding: "4px 0",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "6px",
              boxShadow: "0 2px 4px rgba(26, 115, 232, 0.2)",
              transition: "all 0.3s ease",
              position: "relative"
            }}
          >
            <div style={{
              background: "#fff",
              borderRadius: "4px",
              width: "20px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
              </svg>
            </div>
            <span style={{ fontSize: "13px", fontWeight: "700", letterSpacing: "0.5px" }}>FOLLOW US</span>
          </div>
        </a>
      </div>

      {/* Ad Container */}
      <div className="ad-side w-100 text-center">
        <div className="ad-section" style={{ background: "#fff", padding: "10px", borderRadius: "12px", border: "1px solid #e0e0e0", boxShadow: "0 4px 10px rgba(0,0,0,0.05)" }}>
          <InjectScript
            script={
              window.innerWidth < 991
                ? adtwoHardcode166
                : adtwoHardcode4
            }
          />
        </div>
      </div>
    </div>
  );
};

export default GoogleNewsSidebar;
